/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "5b458c5a88459a5aab4d277c2402455f974466f7";
